
import {View, Model} from "backbone";
import template from 'dashboard/settings/permissions-view.ejs'
import $ from 'jquery';
import DashboardTable  from 'dashboard/BaseDashboardTableView.js';
import Constants from 'Constants';
import util from 'util/Util.js';

class PermissionsView extends View {
    initialize(opts){

        this.template = template;
        this.service = opts.service;
        this.permissionsHeight = Constants.PERMISSIONS_TABLE_HEIGHT;
        let pageWidth = $("#permissionsTable").parent().width();
        this.tableId = "#permissionsList";
        this.detailsName = opts.detailsName;

        this.model.set(
            {
                permissionsModel: {
                    colModel: [
                        {
                            name: 'id',
                            index: 'id',
                            editable: false,
                            hidden: true
                        },
                        {
                            name: 'user',
                            index: 'user',
                            editable: false,
                            hidden: false
                        },
                        {
                            name: 'fullControl',
                            index: 'fullControl',
                            editable: true,
                            edittype: 'checkbox',
                            editoptions: { value: 'true:false' },
                            width: (pageWidth * (10 / 100)),
                            align: "center",
                            formatter: "checkbox",
                            formatoptions: { disabled: false }
                        },
                        {
                            name: 'use',
                            index: 'use',
                            editable: true,
                            edittype: 'select',
                            editoptions: { value: this.getColumnTypeOptions() },
                            width: (pageWidth * (10 / 100)),
                            align: 'center',
                            formatter: 'select',
                            formatoptions: { disabled: false }
                        },
                        {
                            name: 'edit',
                            index: 'edit',
                            editable: true,
                            edittype: 'select',
                            editoptions: { value: this.getColumnTypeOptions() },
                            width: (pageWidth * (10 / 100)),
                            align: 'center',
                            formatter: 'select',
                            formatoptions: { disabled: false }
                        }
                    ],
                    colNames: ['id','User','Full control', 'Use', 'Edit']
                }
            }, {silent: true}
        );
      
        this.events = {
            // 'keyup input[name=Name]':'changeConnectionName',
            // 'change input[name=IsActive]':'changeConnectionStatus',
            'click #addPermission': 'addPermission',
            'click #removePermission': 'removePermission'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    changeConnectionName(){
        return this.service.changeConnectionName.apply(this.service, arguments);
    }

    changeConnectionStatus(){
        return this.service.changeConnectionStatus.apply(this.service, arguments);
    }

    addPermission() {
        return this.service.addPermission.apply(this.service, arguments);
    }

    removePermission() {
        const selectedUser = this.model.get('selectedPermission');
        const permissions = this.model.get('permissions');
        // remove it from data source
        const newPermissions = permissions.filter(p => p.user !== selectedUser);
        // set new permissions
        this.model.set('permissions', newPermissions, {silent:true});
        this.model.set('filteredPermissions', newPermissions, {silent: true});
        // update xml
        this.updateModelPermission(newPermissions);
    }

    updateModelPermission(permissions){
        // First Grabbing the Current Model And the Currently Selected Permission.
        let details = this.model.get(this.detailsName);
        let currentSelection=this.model.get('selectedPermission');
        
        // Grabbing the current User from the model to modify its permissions.
        let selectedUserIndex = details.PermissionsXML.map((user=>{
            return user['@caption'];
        })).indexOf(currentSelection);
        let user = details.PermissionsXML[selectedUserIndex];
        user.Permission=[];

        // Filter permissions by user
        const permissionsTemp = permissions.filter(p => p.user === currentSelection);

        if (permissionsTemp.length > 0) {
            // Loop for each user permission
            permissionsTemp.forEach(permission => {
                if (permission.fullControl){
                    user.Permission.push({ '#text':'allow','@type':'report'});
                    user.Permission.push({ '#text':'allow','@type':'edit'});
                    user.Permission.push({ '#text':'allow','@type':'administer'});
                } else {

                    if(!util.isEmpty(permission.use)){
                        user.Permission.push({ '#text': permission.use,'@type':'report'});
                    }
                    if(!util.isEmpty(permission.edit)){
                        user.Permission.push({ '#text': permission.edit,'@type':'edit'});
                    }
                    if(permission.use === "deny" && permission.edit === "deny"){
                        user.Permission.push({ '#text':'deny','@type':'administer'});    
                    }   
                }
            });

              // Update permissions in model
            details.PermissionsXML[selectedUserIndex] = user;
        } else {
            // remove user in xml
            const newPermissionsXML = details.PermissionsXML.filter(p => p['@caption'] !== currentSelection);
            details.PermissionsXML = newPermissionsXML;
        }        
              
        this.model.set(this.detailsName, details, {silent:true});
        this.model.set('hasChanges', true, {silent:true});
        this.model.set('permissionsChanged', true, { silent: true });
        this.model.trigger('change');

        // disable button to remove until they select another user
        $('#removePermission').attr('disabled', true);

    }

    render(){
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        const details = this.model.get(this.detailsName);

        // If there are permissions
            this.generateConnectionPermissionsStructure();
       
        this.delegateEvents();
        return this;
    }

    generateConnectionPermissionsStructure(){
        const details = this.model.get(this.detailsName);

        const permissions = [];

        if(details.PermissionsXML){
            for (let user of details.PermissionsXML) {
                let itemPermission = {
                    id: user['@id'],
                    user: user['@caption'],
                    fullControl: false,
                    use: '',
                    edit: ''
                };
    
                const setPermission = (permission) => {
                    switch (permission['@type']) {
                        case 'report':
                            itemPermission.use = permission['#text'];
                            break;
                        case 'edit':
                            itemPermission.edit = permission['#text'];
                            break;
                        case 'administer':
                            itemPermission.fullControl = permission['#text'] === 'allow';
                            break;
                    }
                }
    
                if (user.Permission) {
                    if (Array.isArray(user.Permission)) {
                        for (let permission of user.Permission) {
                            setPermission(permission);
                        }
                    }
                    else {
                        setPermission(user.Permission);
                    }
                }
    
                permissions.push(itemPermission);
            }
        }

        this.model.set('permissions', permissions, {silent:true});
        this.model.set('filteredPermissions', permissions, {silent: true});

        this.renderDashboardTable();

    }

    renderDashboardTable(){
        let permissionsListTableOptions = {
            id: "permissionsList",
            // title: "Permissions",
            height: this.permissionsHeight,
            datatype: "local",
            cellEdit: true,
            colModel: this.model.get('permissionsModel').colModel,
            colNames: this.model.get('permissionsModel').colNames,
            multiselect: false,
            items: this.model.get('filteredPermissions'),
            filter: {tag: "User", columnId: "user"}
        }

        this.permissionsTable = new DashboardTable({ model: new Model({ tableOptions: permissionsListTableOptions, currentView: this }), el: '#permissionsTable' });
        this.permissionsTable.render();

        if(this.newPermissionId){
            $('#permissionsTable').setSelection(this.newPermissionId, false);
        }

        $("#permissionsTableOperations").show();
    }

    getColumnTypeOptions() {
        return {
            '': '',
            'allow': 'Allow',
            'deny': 'Deny'
        };
    }

    afterSaveCell (userId, cellName, value, iRow, iCol, self) {
        let gridData = self.model.get('permissions');
        const index = gridData.findIndex(data => data.id === userId);
        const user = gridData[index];

        if (iCol === 3) {
            user.use = value;
            user.fullControl = false;
            self.updateModelPermission(gridData);

        } else if (iCol === 4) {
            user.edit = value;
            user.fullControl = false;
            self.updateModelPermission(gridData);
        }
    }

    onCellSelect(userId, iCol, cellcontent, e, self) {
        let gridData = self.model.get('permissions');
        const index = gridData.findIndex(data => data.id === userId);
        const user = gridData[index];

        // Save selected user in model
        self.model.set('selectedPermission', gridData[index].user, {silent: true});
        $('#removePermission').attr('disabled', false);

        if (iCol === 2){ //If it is the full control checkbox           
            let fullControl = !user.fullControl;
            user.fullControl = fullControl;
            if(fullControl){
                user.use = "allow";
                user.edit = "allow";
            }            
            self.updateModelPermission(gridData);
        } 
    }

    gridComplete() {
        const grid =  $('#permissionsList');

        const posFullControl = 3;
        const posUse = 4;
        const posEdit = 5;

        const cellsFullControl = $(`tbody > tr.jqgrow > td:nth-child(${posFullControl}) > input`,grid[0]);
        const cellsUse = $(`tbody > tr.jqgrow > td:nth-child(${posUse})`,grid[0]);
        const cellsEdit = $(`tbody > tr.jqgrow > td:nth-child(${posEdit})`,grid[0]);

        for (let i=0; i<cellsFullControl.length; i++) {
            let cell = $(cellsFullControl[i]);
            let cellUse = $(cellsUse[i]);
            let cellEdit = $(cellsEdit[i]);

            if (cell.attr('checked') === 'checked') {
                cellUse.addClass('not-editable-cell');
                cellEdit.addClass('not-editable-cell');
            } else {
                cellUse.removeClass('not-editable-cell');
                cellEdit.removeClass('not-editable-cell');
            }
        }
    }   
}

export default PermissionsView;